export const frontmatter = {"nav":"Components","title":"Design Tokens 设计变量","order":1,"group":{"title":"基础","order":998}};
export const toc = [];